(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
if (!customElements.get("s-featured-blog")) {
  customElements.define(
    "s-featured-blog",
    class SectionFeaturedBlog extends HTMLElement {
      constructor() {
        super();

      }

      connectedCallback() {
        this.swiper = new Swiper(this, {
          slidesPerView: 1.2,
          spaceBetween: 20,
          speed: 400,
          enabled: true,
          breakpoints: {
            560: {
              slidesPerView: 2,
              spaceBetween: 20,
              enabled: true
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 20,
              enabled: true
            },
            992: {
              slidesPerView: 4,
              spaceBetween: 20,
              enabled: true
            },
            1200: {
              enabled: false,
              spaceBetween: 0
            }
          }
        })
      }

      disconnectedCallback() {
      }
    }
  );
}

},{}]},{},[1])

